import en from 'src/languages/strings_en';
import ja from 'src/languages/strings_ja';

export const ENABLE_REDUX_DEV_TOOLS = process.env.NODE_ENV !== 'production';

export const THEMES = {
  DEFAULT: 'DEFAULT'
};

export const MESSAGES = {
  en: en,
  ja: ja
};

export const APP_NAME =
  process.env.REACT_APP_DC_DISPLAY_NAME || 'Otemachi App';
